import axios from "axios";
import { BASE_URL } from "./type";

export function getTickets(page = 1, status = '', priority = '') {
    let url = BASE_URL + `tickets?page=${page}`;
    if (status) url += `&status=${status}`;
    if (priority) url += `&priority=${priority}`;
    return axios.get(url);
}

export function getTicket(id) {
    return axios.get(BASE_URL + `tickets/${id}`);
}

export function createTicket(data) {
    return axios.post(BASE_URL + 'tickets', data);
}

export function replyToTicket(id, body) {
    return axios.post(BASE_URL + `tickets/${id}/reply`, { body });
}

export function updateTicketStatus(id, status) {
    return axios.patch(BASE_URL + `tickets/${id}/status`, { status });
}

export function markTicketRead(id) {
    return axios.patch(BASE_URL + `tickets/${id}/read`);
}

export function getUnreadCount() {
    return axios.get(BASE_URL + 'tickets/unread-count');
}
